import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ExternalAnnonceEntry = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const modeParam = searchParams.get("mode") || "assiste";
    const nTypeParam = searchParams.get("nType") || "1";
    const nSTypeParam = searchParams.get("nSType") || "0";
    const typeParam = searchParams.get("type") || "";
    const stepParam = searchParams.get("step") || "saisie";

    const checkedIndexValue = modeParam === "libre" ? 0 : 1;
    const activeIndexTarget = stepParam === "support" ? 2 : 1;

    // Stocker la destination pour qu'AnonymousLogin l'utilise après login
    sessionStorage.setItem("postLoginRedirect", JSON.stringify({
      path: "/home/nouvelle-annonce",
      state: {
        fromExternal: true,
        externalStep: activeIndexTarget,
        externalMode: checkedIndexValue,
        externalType: {
          nType: Number(nTypeParam),
          nSType: Number(nSTypeParam),
          sSType: typeParam,
        },
      },
    }));

    // Stocker aussi séparément pour NouvelleAnnonce
    sessionStorage.setItem("externalAnnonceParams", JSON.stringify({
      externalStep: activeIndexTarget,
      externalMode: checkedIndexValue,
      externalType: {
        nType: Number(nTypeParam),
        nSType: Number(nSTypeParam),
        sSType: typeParam,
      },
    }));

    // Déléguer exactement au même flow que le lien anonyme classique
    navigate("/anonymous-login", { replace: true });
  }, []);

  return (
    <div className="div-spinner">
      <div className="spinner-square">
        <div className="square-1 square"></div>
        <div className="square-2 square"></div>
        <div className="square-3 square"></div>
      </div>
      <p style={{ marginTop: 16, color: "#555" }}>Connexion en cours...</p>
    </div>
  );
};

export default ExternalAnnonceEntry;
